module.exports = __webpack_public_path__ + "static/EuclidTriangle-Light-WebS-86064eabea0bf35d658ad60057fb8496.woff2";